import { Link, Navigate, useNavigate } from "react-router-dom"
import { observer } from "mobx-react"
import { Button, Flex, List } from "antd"

import { balancesStore } from "@src/app/balanceStore"
import { DefaultPageLayout } from "@src/app/layouts/DefaultPageLayout"
import { paths } from "@src/app/paths"
import { dateTimeFormat } from "@src/shared/date"
import css from "./index.module.css"

const { Item } = List

export const WIthdrawDetailsPage = observer(() => {
  const { resetResponse, withdrawDetails } = balancesStore

  if (!withdrawDetails) {
    return Navigate({ to: paths.balances })
  }

  return (
    <DefaultPageLayout title="In progress" url={paths.balances}>
      <Flex align="center" gap={32} vertical>
        <List className={css.list}>
          <Item className={css.item}>
            <div className={css.listTitle}>Address</div>
            <div>{withdrawDetails.data.address}</div>
          </Item>
          <Item className={css.item}>
            <div className={css.listTitle}>Blockchain network</div>
            <div>{withdrawDetails.data.network}</div>
          </Item>
          <Item className={css.item}>
            <div className={css.listTitle}>Date</div>
            <div>{dateTimeFormat(withdrawDetails?.created_at as string)}</div>
          </Item>
          <Item className={css.item}>
            <div className={css.listTitle}>Amount</div>
            <div>{withdrawDetails?.data.amount}</div>
          </Item>
        </List>
        <Link id="GENERATED_ID_WITHDRAWDETAILS_LINK_VOID_1" to={paths.balances}>
          <Button
            id="GENERATED_ID_WITHDRAWDETAILS_BUTTON_GO_TO_DASHBOARD_1"
            onClick={resetResponse}
            size="large"
            type="primary"
          >
            Go to dashboard
          </Button>
        </Link>
      </Flex>
    </DefaultPageLayout>
  )
})
